enum ProductOrderAttachmentType {
    DELIVERY_EVIDENCE = 'DELIVERY_EVIDENCE',
    DELIVERY_ISSUE = 'DELIVERY_ISSUE',
}
export default ProductOrderAttachmentType